import { render, staticRenderFns } from "./VinGoods.vue?vue&type=template&id=690239be"
import script from "./VinGoods.vue?vue&type=script&lang=js"
export * from "./VinGoods.vue?vue&type=script&lang=js"
import style0 from "./VinGoods.vue?vue&type=style&index=0&id=690239be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports